var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noselect",attrs:{"id":"Entry-c"}},[_c('vue-particles',{staticStyle:{"height":"100vh","z-index":"100"},attrs:{"color":"#4BD0A8"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('b',[_c('p',{attrs:{"id":"typedtext"}})])
}]

export { render, staticRenderFns }